export default __webpack_public_path__ + "static/media/5.eef7dbc2.jpg";